import React, { useEffect } from "react";
import Layout from "../../Components/Layout/Layout";
import ContactUsScreen from "../../Components/ContactUs/ContactUs";
import "./Style.css";


const ContactUs = () => {
  useEffect(() => {
    localStorage.removeItem("cns")
    localStorage.removeItem("cip")
    localStorage.removeItem("cdp")
  }, [])
  return (
    <>
      <Layout className={"paddingSet"}>
        <div className="ContactUsScreen-parent">
          <ContactUsScreen />
        </div>
      </Layout>
    </>
  );
};
export default ContactUs;